import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { headerSEOValues, headerSEOExceptions } from "../../../uploads/headerSEOValues";
import { useLocation } from "react-router-dom";

function HeaderSEO({ specialValue, setSpecialValue }) {
  const [activePageSEO, setActivePageSEO] = useState(headerSEOValues["/"]);

  const location = useLocation();

  const defaultBreadcrumb = {
    name: "Accueil, fonds de commerce, titres de société, murs commerciaux",
    item: "/",
  };

  useEffect(() => {
    let pathname = location.pathname;
    if (isException(pathname)) return;

    if (pathname.includes("/conseils-pros/cession-fonds-de-commerce"))
      pathname = "/conseils-pros/cession-fonds-de-commerce";
    if (pathname.includes("/conseils-pros/offre-achat-lettre-intention"))
      pathname = "/conseils-pros/offre-achat-lettre-intention";
    if (pathname.includes("/conseils-pros/compromis-vente-protocole-accord"))
      pathname = "/conseils-pros/compromis-vente-protocole-accord";
    if (pathname.includes("/conseils-pros/estimation-fonds-commerce"))
      pathname = "/conseils-pros/estimation-fonds-commerce";
    if (pathname.includes("/conseils-pros/imposition-plus-value-fonds-commerce"))
      pathname = "/conseils-pros/imposition-plus-value-fonds-commerce";
    if (pathname.includes("/conseils-pros/renouvellement-bail-commercial"))
      pathname = "/conseils-pros/renouvellement-bail-commercial";
    if (pathname.includes("/conseils-pros/bail-commercial-points-importants"))
      pathname = "/conseils-pros/bail-commercial-points-importants";
    if (pathname.includes("/conseils-pros/vente-fonds-commerce")) pathname = "/conseils-pros/vente-fonds-commerce";
    if (pathname.includes("/conseils-pros/credit-vendeur-cession-fonds-commerce"))
      pathname = "/conseils-pros/credit-vendeur-cession-fonds-commerce";
    if (pathname.includes("/conseils-pros/acteurs-cession-fonds-commerce-accompagnement"))
      pathname = "/conseils-pros/acteurs-cession-fonds-commerce-accompagnement";
    if (pathname.includes("/conseils-pros/valorisation-murs-commerciaux"))
      pathname = "/conseils-pros/valorisation-murs-commerciaux";
    if (pathname.includes("/conseils-pros/formalites-cession-fonds-commerce"))
      pathname = "/conseils-pros/formalites-cession-fonds-commerce";
    if (pathname.includes("/conseils-pros/evaluation-entreprises-titres-societe"))
      pathname = "/conseils-pros/evaluation-entreprises-titres-societe";
    if (pathname.includes("/conseils-pros/cession-droit-bail")) pathname = "/conseils-pros/cession-droit-bail";
    if (pathname.includes("/conseils-pros/valorisation-entreprise"))
      pathname = "/conseils-pros/valorisation-entreprise";
    if (pathname.includes("/conseils-pros/donation-avant-cession")) pathname = "/conseils-pros/donation-avant-cession";
    if (pathname.includes("/conseils-pros/apport-cession")) pathname = "/conseils-pros/apport-cession";
    if (pathname.includes("/conseils-pros/trouver-local-commercial"))
      pathname = "/conseils-pros/trouver-local-commercial";
    if (pathname.includes("/conseils-pros/acheter-fonds-de-commerce"))
      pathname = "/conseils-pros/acheter-fonds-de-commerce";
    if (pathname.includes("/conseils-pros/compte-exploitation-previsionnel"))
      pathname = "/conseils-pros/compte-exploitation-previsionnel";
    if (pathname.includes("/conseils-pros/gestion-tresorerie")) pathname = "/conseils-pros/gestion-tresorerie";
    if (pathname.includes("/conseils-pros/accompagnement-creation-entreprise"))
      pathname = "/conseils-pros/accompagnement-creation-entreprise";
    if (pathname.includes("/conseils-pros/calcul-imposition-titre-societe"))
      pathname = "/conseils-pros/calcul-imposition-titre-societe";
    if (pathname.includes("/conseils-pros/cession-entreprise-contrat-travail"))
      pathname = "/conseils-pros/cession-entreprise-contrat-travail";
    if (
      pathname.includes("/conseils-pros/cession-entreprise") &&
      pathname != "/conseils-pros/cession-entreprise-contrat-travail"
    )
      pathname = "/conseils-pros/cession-entreprise";
    if (pathname.includes("/conseils-pros/lbo")) pathname = "/conseils-pros/lbo";
    if (pathname.includes("/conseils-pros/garantie-actif-passif")) pathname = "/conseils-pros/garantie-actif-passif";
    if (pathname.includes("/conseils-pros/business-plan")) pathname = "/conseils-pros/business-plan";
    if (pathname.includes("/conseils-pros/earn-out")) pathname = "/conseils-pros/earn-out";
    if (pathname.includes("/conseils-pros/reprise-entreprise")) pathname = "/conseils-pros/reprise-entreprise";
    if (pathname.includes("/conseils-pros/categorie-erp")) pathname = "/conseils-pros/categorie-erp";
    if (pathname.includes("/conseils-pros/tableau-de-bord-entreprise"))
      pathname = "/conseils-pros/tableau-de-bord-entreprise";
    if (pathname.includes("/conseils-pros/gestion-de-stock")) pathname = "/conseils-pros/gestion-de-stock";
    if (pathname.includes("/conseils-pros/gerer-entreprise")) pathname = "/conseils-pros/gerer-entreprise";
    if (pathname.includes("/conseils-pros/methode-smart")) pathname = "/conseils-pros/methode-smart";
    if (pathname.includes("/conseils-pros/optimiser-process-entreprise"))
      pathname = "/conseils-pros/optimiser-process-entreprise";
    if (pathname.includes("/conseils-pros/chasse-gaspillage-economies-entreprise"))
      pathname = "/conseils-pros/chasse-gaspillage-economies-entreprise";
    if (pathname.includes("/conseils-pros/e-reputation")) pathname = "/conseils-pros/e-reputation";
    if (pathname.includes("/conseils-pros/nantissement-fonds-commerce"))
      pathname = "/conseils-pros/nantissement-fonds-commerce";
    if (pathname.includes("/conseils-pros/hotel-investissement")) pathname = "/conseils-pros/hotel-investissement";
    if (pathname.includes("/conseils-pros/location-gerance-risques-avantages"))
      pathname = "/conseils-pros/location-gerance-risques-avantages";
    if (pathname.includes("/conseils-pros/acte-sous-seing-prive-acte-authentique"))
      pathname = "/conseils-pros/acte-sous-seing-prive-acte-authentique";
    if (pathname.includes("/conseils-pros/choisir-fonds-commerce-boulangerie"))
      pathname = "/conseils-pros/choisir-fonds-commerce-boulangerie";
    if (pathname.includes("/conseils-pros/choisir-agent-immobilier-fonds-commerce"))
      pathname = "/conseils-pros/choisir-agent-immobilier-fonds-commerce";
    if (pathname.includes("/conseils-pros/choisir-fonds-commerce-restaurant-racheter"))
      pathname = "/conseils-pros/choisir-fonds-commerce-restaurant-racheter";
    if (pathname.includes("/conseils-pros/sequestre-fonds-commerce"))
      pathname = "/conseils-pros/sequestre-fonds-commerce";
    if (pathname.includes("/conseils-pros/compte-courant-associe")) pathname = "/conseils-pros/compte-courant-associe";
    if (pathname.includes("/conseils-pros/differences-droit-au-bail-pas-de-porte-droit-entree"))
      pathname = "/conseils-pros/differences-droit-au-bail-pas-de-porte-droit-entree";
    if (pathname.includes("/conseils-pros/comprendre-etablir-compte-resultat"))
      pathname = "/conseils-pros/comprendre-etablir-compte-resultat";
    if (pathname.includes("/conseils-pros/role-expert-comptable-entreprise"))
      pathname = "/conseils-pros/role-expert-comptable-entreprise";
    if (pathname.includes("/conseils-pros/soldes-intermediaires-gestion"))
      pathname = "/conseils-pros/soldes-intermediaires-gestion";
    if (pathname.includes("/conseils-pros/ebe-excedent-brut-exploitation"))
      pathname = "/conseils-pros/ebe-excedent-brut-exploitation";
    if (pathname.includes("/conseils-pros/bilan-comptable-analyse"))
      pathname = "/conseils-pros/bilan-comptable-analyse";
    if (pathname.includes("/conseils-pros/BFR-besoin-fonds-roulement"))
      pathname = "/conseils-pros/BFR-besoin-fonds-roulement";
    if (pathname.includes("/conseils-pros/obligations-comptables-entreprises"))
      pathname = "/conseils-pros/obligations-comptables-entreprises";
    if (pathname.includes("/conseils-pros/amortissement-fonds-commerce"))
      pathname = "/conseils-pros/amortissement-fonds-commerce";
    if (pathname.includes("/conseils-pros/tva-taxe-valeur-ajoutee-entreprise"))
      pathname = "/conseils-pros/tva-taxe-valeur-ajoutee-entreprise";
    if (pathname.includes("/conseils-pros/guide-fiscalite-entreprise"))
      pathname = "/conseils-pros/guide-fiscalite-entreprise";
    if (pathname.includes("/conseils-pros/guide-matrice-BCG")) pathname = "/conseils-pros/guide-matrice-BCG";
    if (pathname.includes("/conseils-pros/benchmark-concurrentiel"))
      pathname = "/conseils-pros/benchmark-concurrentiel";
    if (pathname.includes("/conseils-pros/comment-definir-business-model"))
      pathname = "/conseils-pros/comment-definir-business-model";
    if (pathname.includes("/conseils-pros/fonctionnement-pacte-associes"))
      pathname = "/conseils-pros/fonctionnement-pacte-associes";
    if (pathname.includes("/conseils-pros/statut-eurl-avantages-inconvenients"))
      pathname = "/conseils-pros/statut-eurl-avantages-inconvenients";
    if (pathname.includes("/conseils-pros/statut-snc-particularites-avantages"))
      pathname = "/conseils-pros/statut-snc-particularites-avantages";
    if (pathname.includes("/conseils-pros/statut-sci-caracteristiques-avantages"))
      pathname = "/conseils-pros/statut-sci-caracteristiques-avantages";
    if (pathname.includes("/conseils-pros/societe-civile-professionnelle-avantages-inconvenients"))
      pathname = "/conseils-pros/societe-civile-professionnelle-avantages-inconvenients";
    if (pathname.includes("/conseils-pros/statut-entreprise-individuelle-caracteristiques"))
      pathname = "/conseils-pros/statut-entreprise-individuelle-caracteristiques";
    if (pathname.includes("/conseils-pros/entreprise-choisir-statut-juridique"))
      pathname = "/conseils-pros/entreprise-choisir-statut-juridique";
    if (pathname.includes("/conseils-pros/statut-SAS-avantages-inconvenients"))
      pathname = "/conseils-pros/statut-SAS-avantages-inconvenients";
    if (pathname.includes("/conseils-pros/statut-sasu-avantages-inconvenients"))
      pathname = "/conseils-pros/statut-sasu-avantages-inconvenients";
    if (pathname.includes("/conseils-pros/statut-sarl-avantages-inconvenients"))
      pathname = "/conseils-pros/statut-sarl-avantages-inconvenients";
    if (pathname.includes("/conseils-pros/avantages-franchiser-entreprise"))
      pathname = "/conseils-pros/avantages-franchiser-entreprise";
    if (pathname.includes("/conseils-pros/creer-son-entreprise")) pathname = "/conseils-pros/creer-son-entreprise";
    if (pathname.includes("/conseils-pros/entrepreneuriat-clefs-reussite"))
      pathname = "/conseils-pros/entrepreneuriat-clefs-reussite";
    if (pathname.includes("/conseils-pros/aide-creation-entreprise"))
      pathname = "/conseils-pros/aide-creation-entreprise";
    if (pathname.includes("/conseils-pros/clause-agrement")) pathname = "/conseils-pros/clause-agrement";
    if (pathname.includes("/conseils-pros/gestion-conflit-travail"))
      pathname = "/conseils-pros/gestion-conflit-travail";
    if (pathname.includes("/conseils-pros/proposition-commerciale"))
      pathname = "/conseils-pros/proposition-commerciale";
    if (pathname.includes("/conseils-pros/transformation-digitale-entreprise"))
      pathname = "/conseils-pros/transformation-digitale-entreprise";
    if (pathname.includes("/conseils-pros/methode-ikigai")) pathname = "/conseils-pros/methode-ikigai";
    if (pathname.includes("/conseils-pros/monter-entreprise-sans-argent"))
      pathname = "/conseils-pros/monter-entreprise-sans-argent";
    if (pathname.includes("/conseils-pros/crowdfunding")) pathname = "/conseils-pros/crowdfunding";
    if (pathname.includes("/conseils-pros/business-angel")) pathname = "/conseils-pros/business-angel";
    if (pathname.includes("/conseils-pros/budget-previsionnel")) pathname = "/conseils-pros/budget-previsionnel";
    if (pathname.includes("/conseils-pros/gestion-relation-client"))
      pathname = "/conseils-pros/gestion-relation-client";
    if (pathname.includes("/conseils-pros/taux-profitabilite")) pathname = "/conseils-pros/taux-profitabilite";
    if (pathname.includes("/conseils-pros/cash-flow-definition")) pathname = "/conseils-pros/cash-flow-definition";
    if (pathname.includes("/conseils-pros/compte-sequestre")) pathname = "/conseils-pros/compte-sequestre";
    if (pathname.includes("/conseils-pros/coup-accordeon")) pathname = "/conseils-pros/coup-accordeon";
    if (pathname.includes("/conseils-pros/etude-de-marche")) pathname = "/conseils-pros/etude-de-marche";
    if (pathname.includes("/conseils-pros/comment-investir-tresorerie-entreprise"))
      pathname = "/conseils-pros/comment-investir-tresorerie-entreprise";
    if (pathname.includes("/conseils-pros/bail-precaire")) pathname = "/conseils-pros/bail-precaire";
    if (pathname.includes("/conseils-pros/indice-ilc")) pathname = "/conseils-pros/indice-ilc";
    if (pathname.includes("/conseils-pros/levee-de-fonds")) pathname = "/conseils-pros/levee-de-fonds";
    if (pathname.includes("/conseils-pros/pacte-dutreil")) pathname = "/conseils-pros/pacte-dutreil";
    if (pathname.includes("/conseils-pros/cession-de-parts-sociales"))
      pathname = "/conseils-pros/cession-de-parts-sociales";
    if (pathname.includes("/conseils-pros/bootstrapping")) pathname = "/conseils-pros/bootstrapping";
    if (pathname.includes("/conseils-pros/bic-ou-bnc")) pathname = "/conseils-pros/bic-ou-bnc";
    if (pathname.includes("/conseils-pros/niche-fiscale")) pathname = "/conseils-pros/niche-fiscale";
    if (pathname.includes("/conseils-pros/ratios-financiers")) pathname = "/conseils-pros/ratios-financiers";
    if (pathname.includes("/conseils-pros/rediger-annonce-immobiliere"))
      pathname = "/conseils-pros/rediger-annonce-immobiliere";
    if (pathname.includes("/conseils-pros/cycle-economique")) pathname = "/conseils-pros/cycle-economique";
    if (pathname.includes("/conseils-pros/capital-humain-commerce"))
      pathname = "/conseils-pros/capital-humain-commerce";
    if (pathname.includes("/conseils-pros/obo")) pathname = "/conseils-pros/obo";
    if (pathname.includes("/conseils-pros/bdd-clients")) pathname = "/conseils-pros/bdd-clients";
    if (pathname.includes("/conseils-pros/lbu")) pathname = "/conseils-pros/lbu";
    if (pathname.includes("/conseils-pros/analyse-financiere")) pathname = "/conseils-pros/analyse-financiere";
    // if (pathname.includes("/conseils-pros/") && pathname.length > 15) pathname = "/conseils-pros/:article";
    if (pathname.includes("/guides-agents-immos/les-secrets-d-une-visite-d-affaire-bien-structuree-pour-transformer"))
      pathname = "/guides-agents-immos/les-secrets-d-une-visite-d-affaire-bien-structuree-pour-transformer";
    if (pathname.includes("/guides-agents-immos/utiliser-le-plan-de-financement-pour-valider-le-prix-d-une-affaire"))
      pathname = "/guides-agents-immos/utiliser-le-plan-de-financement-pour-valider-le-prix-d-une-affaire";
    if (pathname.includes("/guides-agents-immos/les-secrets-d-une-prospection-reussie"))
      pathname = "/guides-agents-immos/les-secrets-d-une-prospection-reussie";
    if (
      pathname.includes(
        "/guides-agents-immos/comment-faire-une-bonne-decouverte-d-un-commerce-ou-d-une-entreprise-a-vendre",
      )
    )
      pathname = "/guides-agents-immos/comment-faire-une-bonne-decouverte-d-un-commerce-ou-d-une-entreprise-a-vendre";
    if (pathname.includes("/guides-agents-immos/comment-rediger-une-bonne-annonce-de-vente-de-fonds-de-commerce"))
      pathname = "/guides-agents-immos/comment-rediger-une-bonne-annonce-de-vente-de-fonds-de-commerce";
    if (pathname.includes("/guides-agents-immos/les-cles-pour-bien-cerner-l-acquereur-d-un-commerce"))
      pathname = "/guides-agents-immos/les-cles-pour-bien-cerner-l-acquereur-d-un-commerce";
    if (pathname.includes("/guides-agents-immos/les-secrets-du-compromis-de-vente"))
      pathname = "/guides-agents-immos/les-secrets-du-compromis-de-vente";
    if (pathname.includes("/guides-agents-immos/comprendre-la-taxe-sur-la-plus-value-d-un-fonds-de-commerce"))
      pathname = "/guides-agents-immos/comprendre-la-taxe-sur-la-plus-value-d-un-fonds-de-commerce";
    if (pathname.includes("/guides-agents-immos/comment-monter-un-dossier-de-vente-d-affaire-pro-et-convaincant"))
      pathname = "/guides-agents-immos/comment-monter-un-dossier-de-vente-d-affaire-pro-et-convaincant";
    if (pathname.includes("/guides-agents-immos/comment-reduire-temps-entre-offre-et-compromis-vente-fonds-commerce"))
      pathname = "/guides-agents-immos/comment-reduire-temps-entre-offre-et-compromis-vente-fonds-commerce";
    if (pathname.includes("/guides-agents-immos/comment-maximiser-chances-acquereur-obtenir-accord-pret-professionnel"))
      pathname = "/guides-agents-immos/comment-maximiser-chances-acquereur-obtenir-accord-pret-professionnel";
    if (pathname.includes("/guides-agents-immos/prospection-commerces-vente-quelles-affaires-cibler-ou-eviter"))
      pathname = "/guides-agents-immos/prospection-commerces-vente-quelles-affaires-cibler-ou-eviter";
    // if (pathname.includes("/guides-agents-immos/") && pathname.length > 21) pathname = "/guides-agents-immos/:article";
    if (pathname.includes("/detail-parcours/murs-commerciaux")) pathname = "/detail-parcours/murs-commerciaux";
    if (pathname.includes("/detail-parcours/fonds-de-commerce")) pathname = "/detail-parcours/fonds-de-commerce";
    if (pathname.includes("/detail-parcours/titres-de-societe")) pathname = "/detail-parcours/titres-de-societe";

    if (!headerSEOValues[pathname]) return console.warn("Aucun Header SEO pour cette URL");

    if (headerSEOValues[pathname].useSpecialValue && specialValue) setActivePageSEO(specialValue);
    else {
      setActivePageSEO(headerSEOValues[pathname]);
      setSpecialValue(null);
    }
  }, [location, specialValue]);

  function isException(pathname) {
    for (let i = 0; i < headerSEOExceptions.length; i++) {
      if (pathname.includes(headerSEOExceptions[i])) return true;
    }

    return false;
  }

  return (
    <Helmet>
      <meta charset='UTF-8' />
      <meta http-equiv='X-UA-Compatible' content='IE=edge' />
      <meta name='content-language' content='fr' />
      <meta name='viewport' content='width=device-width, initial-scale=1.0' />
      <meta name='author' content={activePageSEO?.author} />
      <meta name='theme-color' content='#252b41' />

      <title>{activePageSEO?.title}</title>
      <meta name='description' content={activePageSEO?.description} />

      <meta property='og:type' content='website' />
      <meta property='og:title' content={activePageSEO?.title} />
      <meta property='og:description' content={activePageSEO?.description} />
      <meta property='og:image' content={activePageSEO?.image} />
      <meta property='og:image:width' content='1200' />
      <meta property='og:image:height' content='286' />
      <meta property='og:url' content={process.env.REACT_APP_URL + activePageSEO?.url} />

      <meta name='twitter:title' content={activePageSEO?.title} />
      <meta name='twitter:description' content={activePageSEO?.description} />
      <meta name='twitter:image' content={activePageSEO?.image} />
      <meta name='twitter:card' content='summary_large_image' />
      <meta name='twitter:site' content='@mon_twitter' />

      {/* index, follow ||noindex, nofollow */}
      <meta name='robots' content={activePageSEO?.robots} />
      <link rel='canonical' href={process.env.REACT_APP_URL + activePageSEO?.url} />

      {/* follow ||nofollow */}
      <link rel={activePageSEO?.follow} href={process.env.REACT_APP_URL + activePageSEO?.url} />

      <link rel='icon' type='image/png' href='./assets/img/Favicon.svg' />

      <script type='application/ld+json'>
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Organization",
          "name": activePageSEO?.author,
          "url": process.env.REACT_APP_URL + activePageSEO?.url,
          "logo": activePageSEO?.image,
        })}
      </script>

      <script type='application/ld+json'>
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [defaultBreadcrumb, ...(activePageSEO?.breadcrumb ? activePageSEO?.breadcrumb : [])]
            .map(
              (route, index) =>
                route && {
                  "@type": "ListItem",
                  "position": index + 1,
                  "name": route.name,
                  "item": process.env.REACT_APP_URL + route.item,
                },
            )
            .filter(route => route),
        })}
      </script>

      {activePageSEO.faq && (
        <script type='application/ld+json'>
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": activePageSEO.faq.map(entity => ({
              "@type": "Question",
              "name": entity.title,
              "acceptedAnswer": {
                "@type": "Answer",
                "text": entity.answer,
              },
            })),
          })}
        </script>
      )}
    </Helmet>
  );
}

export default HeaderSEO;
